import VDataIterator from './VDataIterator'

VDataIterator.install = function install (Vue) {
  Vue.component(VDataIterator.name, VDataIterator)
}

export default VDataIterator



// WEBPACK FOOTER //
// ./src/components/VDataIterator/index.js